// FIXME TESTAR!!!

(function () {
  'use strict';

    angular.module('mgpCorregedoriaApp.validacao')
    .directive('modalDetalheAnalitico', ModalDetalheAnalitico);

    function ModalDetalheAnalitico(){
      var directive = {

        restrict: 'E',
        template: '<a href="" ng-click="vm.openModal()" title="Detalhamento Analítico">{{vm.title}}</a>',
        scope: {
            title: '@',
            id: '@',
            pess: '@',
            rel: '@'
        },
        controller: 'ModalDetalheAnaliticoDirectiveController',
        controllerAs: 'vm',
        bindToController: true

      };
      return directive;
    }        
})();
